import { Slugify } from './Slugify';

export const NameToArray = (source) => {
    let array = [];
    for (let i = 0; i < source.length; i++) {
        array.push(Slugify(source[i].name));
    }
    array.unshift('-- choose option --')
    return array;
}